<template>
  <div>
    <van-nav-bar
      title="银行卡信息"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/recharge')"
    >
      <template #right>
        <!-- <van-icon name="wechat" size="25" @click="openQchat()" /> -->
        <!-- <van-image
          width="28px"
          height="22px"
          :src="require('../assets/images/chatbar.png')"
          @click="openQchat()"
        /> -->
        <span @click="openQchat()" class="chatTextDesign">在线客服</span>
      </template>
    </van-nav-bar>

    <div class="detail" v-if="type === 3" style="">
      <van-row class="rowStyle">
        <van-col span="5"><span>当前余额:</span></van-col>
        <van-col span="19" style="text-align: left"
          ><span>{{ cash }}元</span>
        </van-col>
      </van-row>

      <van-row style="padding: 10px 0px 20px;"
        ><van-col span="3"
          ><img
            style="width: 33px; padding-top: 5px"
            src="../assets/images/rechargeicon.png"
        /></van-col>
        <van-col
          span="19"
          style="padding-left: 10px; padding-top: 10px; font-size: 14px"
          ><span>{{ rechargeTypeName }}</span></van-col
        >
        <van-col span="2" style="padding-top: 7px"
          ><van-icon color="#ee0a24" size="27px" name="success"
        /></van-col>
      </van-row>
      <div style="padding-right: 12px;">
        <div v-html="notice_1_1"></div>
        <!-- <p>充值须知 ：</p>
        <van-row>
            <van-col span="1">1、</van-col>
            <van-col span="23">
            请每一次充值必须获取最新帐号，以免充值无效。<br /></van-col>
        </van-row>
        <van-row>
            <van-col span="1">2、</van-col>
            <van-col span="23">
            请必须使用本人帐号充值，避免查不到账。<br /></van-col>
        </van-row>
        <van-row>
            <van-col span="1">3、</van-col>
            <van-col span="23">
            转账成功后点“我已转账，申请充值”，平台确认后到账。<br /></van-col>
        </van-row>
        <van-row>
            <van-col span="1">4、</van-col>
            <van-col span="23">
            单笔充值请勿超过4.5万，充值4.5万以上请联系客服申请大额充值帐户。<br /></van-col>
        </van-row>
        <van-row>
            <van-col span="1">5、</van-col>
            <van-col span="23">
            单笔充值20万以上，请提前一天联系客服申请vip充值帐户。<br /></van-col>
        </van-row> -->
      </div>

      <van-row style="padding-top: 30px"
        ><van-col span="5"><span class="bankDetails">付款金额:</span></van-col>
        <van-col span="16"
          ><span class="bankDetails">{{ amount }}元</span></van-col
        >
        <van-col span="3" style="text-align: right; color: #ee0a24">
          <span class="bankDetails" @click="handleCopy(amount)"
            >复制</span
          ></van-col
        >
      </van-row>

      <van-row style="padding-top: 10px"
        ><van-col span="5"><span class="bankDetails">开户姓名:</span></van-col>
        <van-col span="16"
          ><span class="bankDetails">{{ companyBank.name }}</span></van-col
        >
        <van-col span="3" style="text-align: right; color: #ee0a24">
          <span class="bankDetails" @click="handleCopy(companyBank.name)"
            >复制</span
          ></van-col
        >
      </van-row>

      <van-row style="padding-top: 10px"
        ><van-col span="5"><span class="bankDetails">收款卡号:</span></van-col>
        <van-col span="16"
          ><span class="bankDetails">{{ companyBank.card }}</span></van-col
        >
        <van-col span="3" style="text-align: right; color: #ee0a24">
          <span class="bankDetails" @click="handleCopy(companyBank.card)"
            >复制</span
          ></van-col
        >
      </van-row>

      <van-row style="padding-top: 10px"
        ><van-col span="5"><span class="bankDetails">银行名称:</span></van-col>
        <van-col span="16"
          ><span class="bankDetails">{{ companyBank.bank }}</span></van-col
        >
        <van-col span="3" style="text-align: right; color: #ee0a24">
          <span class="bankDetails" @click="handleCopy(companyBank.bank)"
            >复制</span
          ></van-col
        >
      </van-row>

      <van-row style="padding-top: 10px"
        ><van-col span="5"><span class="bankDetails">开户支行:</span></van-col>
        <van-col span="16"
          ><span class="bankDetails">{{ companyBank.address }}</span></van-col
        >
        <van-col span="3" style="text-align: right; color: #ee0a24">
          <span class="bankDetails" @click="handleCopy(companyBank.address)"
            >复制</span
          ></van-col
        >
      </van-row>

      <van-row style="padding-top: 10px">
        <van-button
          round
          block
          type="danger"
          native-type="submit"
          size="small"
          @click="rechargeNext"
        >
          充值
        </van-button></van-row
      >

      <van-row style="padding-top: 40px;">
        <div v-html="notice_2_2"></div>
        <!-- <p class="red">使用说明:</p>
        <p>转账后3-10分钟充值到账，如未到账，请联系在线客服或专属客服处理。</p> -->
      </van-row>
    </div>

    <!-- =====================================type 6========================================== -->

    <div class="detail" v-if="type === 6">
      <van-cell title="当前余额" style="padding: 10px 0px">
        <template #default>
          <span>{{ cash }}元</span>
        </template>
      </van-cell>

      <div style="font-size: 12px">
        <p>温馨提醒：</p>
        <p>
          请用本人({{
            realName
          }})的账号自行转账后点《我已成功付款》，即可入款\n转账金额须与系统一致，若有小数须带小数，否则次日到账
        </p>
      </div>

      <van-row style="padding: 10px 0px"
        ><van-col span="3"
          ><img
            style="width: 38px; padding-top: 5px"
            src="../assets/images/rechargeicon.png"
        /></van-col>
        <van-col span="19" style="padding-left: 10px; padding-top: 15px"
          ><span>{{ rechargeTypeName }}</span></van-col
        >
        <van-col span="2" style="padding-top: 11px"
          ><van-icon color="#ee0a24" size="27px" name="success"
        /></van-col>
      </van-row>

      <div>
        <div v-html="notice_2_1"></div>
        <!-- <p>充值须知:</p>
        <p>1. 请勿保留旧卡转账，会造成无法充值。</p>
        <p>2. 请用本人账号自行通过手机/电脑/银行向以下账号转账。</p>
        <p>3. 转账成功后点“我已转账，申请充值”，平台确认后到账。</p>
        <p>4.转账金额须与系统一致，若有小数须带小数，否则次日到账。</p> -->
      </div>

      <van-row style="padding-top: 25px"
        ><van-col span="5"><span class="bankDetails">付款金额:</span></van-col>
        <van-col span="16"
          ><span class="bankDetails">{{ amount }}元</span></van-col
        >
        <van-col span="3" style="text-align: right; color: #ee0a24">
          <span class="bankDetails" @click="handleCopy(amount)"
            >复制</span
          ></van-col
        >
      </van-row>

      <van-row style="padding-top: 10px"
        ><van-col span="5"><span class="bankDetails">付款时间:</span></van-col>
        <van-col span="16"
          ><span class="bankDetails"
            >请在 <span class="red">{{ threeBank.time }}</span> 之前付款</span
          ></van-col
        >
      </van-row>

      <van-row style="padding-top: 10px"
        ><van-col span="5"><span class="bankDetails">付款金额:</span></van-col>
        <van-col span="16"
          ><span class="bankDetails">{{ threeBank.money }}</span
          ><span class="bankDetails red">须带小数以此一致</span></van-col
        >
        <van-col span="3" style="text-align: right; color: #ee0a24">
          <span class="bankDetails" @click="handleCopy(threeBank.money)"
            >复制</span
          ></van-col
        >
      </van-row>

      <van-row style="padding-top: 10px"
        ><van-col span="5"><span class="bankDetails">开户名称:</span></van-col>
        <van-col span="16"
          ><span class="bankDetails">{{ threeBank.name }}</span></van-col
        >
        <van-col span="3" style="text-align: right; color: #ee0a24">
          <span class="bankDetails" @click="handleCopy(threeBank.name)"
            >复制</span
          ></van-col
        >
      </van-row>

      <van-row style="padding-top: 10px"
        ><van-col span="5"><span class="bankDetails">收款卡号:</span></van-col>
        <van-col span="16"
          ><span class="bankDetails">{{ threeBank.card }}</span></van-col
        >
        <van-col span="3" style="text-align: right; color: #ee0a24">
          <span class="bankDetails" @click="handleCopy(threeBank.card)"
            >复制</span
          ></van-col
        >
      </van-row>

      <van-row style="padding-top: 10px"
        ><van-col span="5"><span class="bankDetails">收款银行:</span></van-col>
        <van-col span="16"
          ><span class="bankDetails">{{ threeBank.bank }}</span></van-col
        >
        <van-col span="3" style="text-align: right; color: #ee0a24">
          <span class="bankDetails" @click="handleCopy(threeBank.bank)"
            >复制</span
          ></van-col
        >
      </van-row>

      <van-row style="padding-top: 40px">
        <div v-html="notice_2_2"></div>
        <!-- <p class="red">温馨提示:</p>
        <p>
          1-部分转账带小数是系统快速判断入款的需要，否则次日到账。举例提交100元，系统显示100.02元，请转100.02元即可到账。
        </p>
        <p>2-若10分钟内若未入款，请联系在线客服或专属客服。</p> -->
      </van-row>

      <van-row style="padding-top: 10px">
        <van-button
          round
          block
          type="danger"
          native-type="submit"
          size="small"
          @click="rechargeNext"
        >
          充值
        </van-button></van-row
      >
    </div>

    <!-- ======================= type 7 / 8 / 9 =============================================== -->

    <div class="detail" v-if="type === 7 || type === 8 || type === 9">
      <iframe
        :src="recharge.url"
        frameborder="0"
        width="100%"
        :height="heigh"
      ></iframe>
    </div>

    <!-- ======================= type 12 =============================================== -->

    <div class="detail" v-if="type === 12">
      <van-row class="rowStyle">
        <van-col span="5"><span>当前余额:</span></van-col>
        <van-col span="19" style="text-align: left"
          ><span>{{ cash }}元</span>
        </van-col>
      </van-row>

      <van-row style="padding: 10px 0px"
        ><van-col span="3"
          ><img
            style="width: 33px; padding-top: 5px"
            src="../assets/images/rechargeicon.png"
        /></van-col>
        <van-col
          span="19"
          style="padding-left: 10px; padding-top: 10px; font-size: 14px"
          ><span> {{ rechargeTypeName }}</span></van-col
        >
        <van-col span="2" style="padding-top: 7px"
          ><van-icon color="#ee0a24" size="27px" name="success"
        /></van-col>
      </van-row>
      <div>
        <div v-html="notice_2_1"></div>
        <!-- <p>充值须知：</p>
        <p>1、重复支付修改金额充值无法到账，概不负责。</p>
        <p>2、平台以到账数量为准，到账数量=转账数量-转账数续费。</p>
        <p>3、扫描二维码或复制地址充值，仅接受TRC20-USDT。</p> -->
      </div>

      <van-row style="padding-top: 30px"
        ><van-col span="5" style="margin-top: -1px"
          ><span class="bankDetails">支付倒计时: </span></van-col
        >
        <van-col span="5" id="timeStyle"
          ><Countdown :deadline="timerCount"></Countdown
        ></van-col>
      </van-row>

      <van-row style="padding-top: 10px"
        ><van-col span="21"
          ><span class="bankDetails"
            >请付<span style="color: red"
              ><b>{{ crypto.USDTAmount }}</b></span
            > USDT<br />到账金额<b>{{ crypto.money }}</b
            >元<br /><b>USDT（TRC20）充值二维码</b></span
          ></van-col
        >
        <van-col span="3" style="text-align: right; color: #ee0a24">
          <span class="bankDetails" @click="handleCopy(crypto.USDTAmount)"
            >复制</span
          ></van-col
        >
      </van-row>

      <van-row style="padding-top: 10px">
        <van-col span="8"> </van-col>
        <van-col span="8" style="text-align: center"
          ><span class="bankDetails"> <div id="qrcode"></div> </span
        ></van-col>
        <van-col span="8"> </van-col>
      </van-row>

      <van-row style="padding-top: 10px"
        ><van-col span="21"
          ><p class="bankDetails">USDT（TRC20）充值地址：</p>
          <p style="font-size: 12px" class="bankDetails">{{ crypto.qrCode }}</p>
        </van-col>
        <van-col span="3" style="text-align: right; color: #ee0a24">
          <span class="bankDetails" @click="handleCopy(crypto.qrCode)"
            >复制</span
          ></van-col
        >
      </van-row>

      <van-row style="padding-top: 40px">
        <van-col span="11">
          <van-button
            style="background: #ffffff; border: 1px solid red"
            round
            block
            type=""
            size="small"
            native-type="submit"
            @click="$router.push('/member/recharge')"
          >
            取消转账
          </van-button>
        </van-col>
        <van-col span="2"> </van-col>
        <van-col span="11">
          <van-button
            round
            block
            type="danger"
            native-type="submit"
            size="small"
            @click="rechargeNext"
          >
            我已转账 申请充值
          </van-button>
        </van-col>
      </van-row>

      <van-row style="padding-top: 40px">
        <div v-html="notice_2_2"></div>
        <!-- <p class="red">温馨提示：</p>
        <p class="red">请转账后请截图发给在线客服或专属客服确认，申请充值。</p>
        <p class="red">
          需等待<b>1-15</b>分钟，整个网络节点上有一定确认数后，才会实际到账。
        </p> -->
      </van-row>
    </div>
    <!-- ============================== Start change channel popup ========================== -->
    <van-popup
      v-model="showTradeChannelPopup"
      closeable
      id="tradingAgreePop"
      style="width: 85%"
    >
      <div
        v-html="trade_rules_content_top"
        style="overflow-y: scroll; max-height: 320px; margin: 10px"
      ></div>
      <div style="text-align: center; padding: 0px 10px">
        <van-button
          type="danger"
          size="large"
          @click="agreeTradeRules"
          style="width: 50%; height: 30%; padding: 3px; border-radius: 6px"
          >我已经明白
        </van-button>
        <div
          v-html="trade_rules_content_bottom"
          style="text-align: center; margin: 10px"
        ></div>
      </div>
    </van-popup>
    <!-- ============================== End change channel popup ========================== -->
    <CommonLoading ref="commonLoader"></CommonLoading>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Countdown from "vuejs-countdown";
import { Toast } from "vant";
import { version } from "../../package";
import { Browser } from "@capacitor/browser";
import CommonLoading from "./CommonLoading";
export default {
  components: { Countdown },
  name: "RechargeInfo",
  components: {
    CommonLoading,
  },
  data() {
    return {
      selectedTypeId: "",
      notice_1_1: "",
      notice_2_1: "",
      notice_2_2: "",
      recharge: {
        money: "",
        url: "",
      },
      timerCount: "",
      userBank: {},
      companyBank: {
        name: "",
        card: "",
        bank: "",
        address: "",
      },
      threeBank: {
        time: "",
        money: "",
        name: "",
        card: "",
        bank: "",
        address: "",
      },
      type: 0,
      cash: 0,
      heigh: window.innerHeight - 150,
      realName: "",
      amount: 0,
      crypto: {
        money: 0,
        USDTAmount: "",
        qrCode: "",
        endTime: 0,
        rechargeId: 0,
      },
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      qserver_url: "",
      rechargeTypeName: "",
    };
  },
  methods: {
    openQchat() {
      if (Capacitor.getPlatform() === "android") {
        //check if android app, if android app use native plugin to open popup
        Browser.open({ url: this.$store.state.chat_server_url });
      } else {
        window.open(this.$store.state.chat_server_url);
      }
    },
    get_qchat_server_url() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "server_url",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            var data = res.data.data;
            that.qserver_url = data;
            that.$store.commit("chatServerUrl", that.qserver_url);
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    getUser() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            that.cash = resData.data.cash;
            that.realName = that.$store.state.user.real;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    getRechargeType() {
      let that = this;
      let type = parseInt(that.$route.query.type);
      let money = parseInt(that.$route.query.number);
      if (
        type !== 3 &&
        type !== 6 &&
        type !== 7 &&
        type !== 8 &&
        type !== 9 &&
        type !== 10 &&
        type !== 12
      ) {
        that.$toast.fail({
          message: "非法进入",
          onClose: function () {
            that.$router.push("/member/recharge");
          },
        });
        return false;
      } else if (money < 100 && isNaN(money)) {
        that.$toast.fail({
          message: "非法进入",
          onClose: function () {
            that.$router.push("/member/recharge");
          },
        });
        return false;
      } else {
        that.type = type;
        that.recharge.money = money;
      }

      switch (that.type) {
        case 3:
          that.getCompanyBank();
          break;
        case 6:
          that.getThreeBank();
          break;
        case 7:
          that.getYfb();
          break;
        case 8:
          that.getAiPay();
          break;
        case 9:
          that.getYf();
          break;
        case 10:
          that.getQt();
          break;
      }
    },
    getCompanyBank() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "offline_info",
            token: sessionStorage.getItem("token"),
            number: that.amount,
          },
        })
        .then(function (res) {
          let resData = res.data.data;
          if (res.data.code == 1) {
            if (that.type == 8) {
              that.companyBank.card = "联系在线客服";
            } else {
              that.companyBank = resData.bank;
            }
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          } else {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    getThreeBank() {
      let that = this;
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "offline_recharge",
            token: sessionStorage.getItem("token"),
            number: that.recharge.money,
            type: 6,
            recharge_id: that.selectedTypeId 
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            let resData = res.data;
            that.threeBank.name = resData.data.receiveBankAccountName;
            that.threeBank.card = resData.data.receiveBankAccountNo;
            that.threeBank.bank = resData.data.receiveBankName;
            that.threeBank.money = resData.data.receiveOrderAmount;
            let endTime = Number(that.$moment().format("x"));
            endTime = endTime + 10 * 60 * 1000;
            that.threeBank.time = that
              .$moment(endTime)
              .format("YYYY-MM-DD HH:mm:ss");
          } else if (res.data.code == 2) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.getTradeChannel();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.$refs.commonLoader.hideCommonLoadigIcon();
        });
    },
    getYfb() {
      let that = this;
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "offline_recharge",
            token: sessionStorage.getItem("token"),
            number: that.recharge.money,
            type: 7,
            recharge_id: that.selectedTypeId
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            let resData = res.data;
            that.recharge.url = resData.data.url;
          } else if (res.data.code == 2) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.getTradeChannel();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.$refs.commonLoader.hideCommonLoadigIcon();
        });
    },
    getAiPay() {
      let that = this;
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "offline_recharge",
            token: sessionStorage.getItem("token"),
            number: that.recharge.money,
            type: 8,
            recharge_id: that.selectedTypeId
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            let resData = res.data;
            that.recharge.url = resData.data.url;
          } else if (res.data.code == 2) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.getTradeChannel();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.$refs.commonLoader.hideCommonLoadigIcon();
        });
    },
    getYf() {
      let that = this;
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "offline_recharge",
            token: sessionStorage.getItem("token"),
            number: that.recharge.money,
            type: 9,
            recharge_id: that.selectedTypeId
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            let resData = res.data;
            window.open(resData.data.url);
            that.$dialog
              .confirm({
                title: "提示",
                message: "请确认您已付款！重复提交会影响到账时间",
              })
              .then(() => {
                that.$store.commit("rechargeTypeNine", true);
                that.$router.push("/member/members");
              })
              .catch(() => {
                // on cancel
              });
          } else if (res.data.code == 2) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.getTradeChannel();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.$refs.commonLoader.hideCommonLoadigIcon();
        });
    },
    getQt() {
      let that = this;
       that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "offline_recharge",
            token: sessionStorage.getItem("token"),
            number: that.recharge.money,
            type: 10,
            recharge_id: that.selectedTypeId
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            let resData = res.data;
            window.open(resData.data.url);
            that.$dialog
              .confirm({
                title: "提示",
                message: "请确认您已付款！重复提交会影响到账时间",
              })
              .then(() => {
                that.$store.commit("rechargeTypeNine", true);
                that.$router.push("/member/members");
              })
              .catch(() => {
                // on cancel
              });
          } else if (res.data.code == 2) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.getTradeChannel();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.$refs.commonLoader.hideCommonLoadigIcon();
        });
    },
    handleCopy(value) {
      let copy = value;
      let oInput = document.createElement("input");
      oInput.value = copy;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      this.$toast.success({
        message: "复制成功",
      });
      oInput.remove();
    },
    rechargeNext() {
      let that = this;
      switch (that.type) {
        case 3:
        case 8:
          that.rechargeCompany();
          break;
        case 6:
        case 7:
          that.$toast.success({
            message: "充值申请成功,尽快完成后续操作,联系客服吧",
            onClose: function () {
              that.$router.push("/member/detailed_log");
            },
          });
          break;
        case 12:
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "recharge_sure",
                token: sessionStorage.getItem("token"),
                id: that.crypto.rechargeId,
              },
            })
            .then(function (res) {
              if (res.data.code == 1) {
                that.$toast.success({
                  message: res.data.msg,
                  type: "success",
                  onClose: function () {
                    that.$router.push("/member/detailed_log");
                  },
                });
              } else if (res.data.code == 2) {
                that.getTradeChannel();
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            });

          break;
      }
    },
    rechargeCompany() {
      let that = this;
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "offline_recharge",
            token: sessionStorage.getItem("token"),
            number: that.recharge.money,
            type: that.type,
            card: that.companyBank.card,
            recharge_id: that.selectedTypeId
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.$toast.success({
              message: res.data.msg,
              forbidClick: "true",
              onClose: function () {
                that.$router.push("/member/members");
              },
            });
          } else if (res.data.code == 2) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.getTradeChannel();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.$toast.fail(res.data.msg);
          }
        })
        .catch(() => {
          that.$refs.commonLoader.hideCommonLoadigIcon();
        });
    },
    qrcode(url) {
      setTimeout(function () {
        let qrcode = new QRCode(document.getElementById("qrcode"), {
          width: 100,
          height: 100,
          text: url, // 二维码地址
        });
      }, 0);
    },

    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      // Toast.loading();
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "trade_popup",
            token: sessionStorage.getItem("token"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            // Toast.clear();
            that.$refs.commonLoader.hideCommonLoadigIcon();
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
            // Toast.clear();
            // that.$toast.fail(res.data.msg);
            that.$refs.commonLoader.hideCommonLoadigIcon();
          }
        })
        .catch(() => {
          // Toast.loading();
          that.$refs.commonLoader.hideCommonLoadigIcon();
        });
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "modify_trade_status",
            token: sessionStorage.getItem("token"),
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg,
            });
            that.showTradeChannelPopup = false;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },

    Timer() {
      var minutesToAdd = 30;
      var currentDate = new Date();
      var newTime = new Date(currentDate.getTime() + minutesToAdd * 60000);
      this.timerCount = newTime.toString();
    },
    showRechargeTypeName() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "account",
            token: sessionStorage.getItem("token"),
            action: "rechargetype",
            app_version: version,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            let resData = res.data;
            let rechargeType = resData.data.rechargeType;
            let rechargeTypeId = that.$route.query.rechargeTypeId;
            let SelectedType = rechargeType.find(
              (o) => o.id == rechargeTypeId
            );
            if (!SelectedType) {
              SelectedType = rechargeType.find(
                (o) => o.type == that.$route.query.type
              );
            }
            if (!SelectedType) {
              return;
            }
            that.rechargeTypeName = SelectedType.name;
            that.notice_1_1 = SelectedType.notice_1_1;
            that.notice_2_1 = SelectedType.notice_2_1;
            that.notice_2_2 = SelectedType.notice_2_2;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    }
  },
  mounted: function () {
    let that = this;
    this.get_qchat_server_url();
    that.amount = that.$route.query.number;
    that.crypto.money = that.$route.query.number;
    that.crypto.money = that.$route.query.number;
    that.crypto.USDTAmount = that.$route.query.USDTAmount;
    that.crypto.qrCode = that.$route.query.qrCode;
    that.crypto.rechargeId = that.$route.query.rechargeId;
    that.selectedTypeId = that.$route.query.rechargeTypeId;
    that.qrcode(this.crypto.qrCode);
    that.isLogin();
    that.getUser();
    that.getRechargeType();
    that.Timer();
    that.showRechargeTypeName();
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.detail {
  width: 90%;
  margin: 10px auto 0;
}

.detail p {
  font-size: 12px;
  margin: 2px 0px;
}

.right {
  float: right;
}

.red {
  color: #ee0a24;
}

.bankDetails {
  font-size: 13px;
}

.agency_qrcode {
  width: 100%;
  text-align: center;
}

.vuejs-countdown li p {
  margin: 7px !important;
}

.rowStyle {
  padding: 10px 0px;
  border-bottom: 1px solid #ebedf0;
  font-size: 14px;
}
.chatTextDesign {
  color: #ffffff;
  font-size: 14px;
  padding: 0px 12px;
  border-radius: 6px;
}
</style>

<style>
#timeStyle .vuejs-countdown .digit {
  font-size: 15px !important;
}
#timeStyle .vuejs-countdown .text {
  display: none !important;
}
#timeStyle .vuejs-countdown li {
  margin: 0px !important;
}
#timeStyle .vuejs-countdown li:after {
  content: ":" !important;
  position: absolute !important;
  top: -1px !important;
  right: -4px !important;
  font-size: 18px !important;
}
#timeStyle .vuejs-countdown li:last-of-type:after {
  content: "" !important;
}

#tradingAgreePop p {
  margin: 0 !important;
}

#tradingAgreePop .van-popup__close-icon--top-right {
  top: 0px;
  right: 0px;
}
</style>





// WEBPACK FOOTER //
// src/components/RechargeInfo.vue